import { useState } from "react";

interface ActionErrorDialogState {
  isOpen: boolean;
  title: string;
  description: string;
}

export function useActionErrorDialog() {
  const [dialogState, setDialogState] = useState<ActionErrorDialogState>({
    isOpen: false,
    title: "",
    description: "",
  });

  const showError = (title: string, description: string) => {
    setDialogState({
      isOpen: true,
      title,
      description,
    });
  };

  const hideError = () => {
    setDialogState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  return {
    isOpen: dialogState.isOpen,
    title: dialogState.title,
    description: dialogState.description,
    onOpenChange: hideError,
    showError,
  };
}
